<template>
  <div>
    <v-progress-circular color="primary"></v-progress-circular>
  </div>
</template>

<script lang="ts">
import { auth0Module } from "@/store/dataModules/auth0Module";
import { defineComponent } from "vue";
export default defineComponent({
  name: "Logout",

  mounted() {
    this.logout();
  },

  methods: {
    logout() {
      localStorage.clear();
      auth0Module.logout();
    },
  },
});
</script>
